import {
  ActionIcon,
  Box,
  Group,
  Stack,
  Tabs,
  Title,
  Divider,
} from "@mantine/core"
import { IconArrowLeft } from "@tabler/icons-react"
import { head } from "lodash"
import { ReactNode, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { PageLink } from "../../layout/Page/Page.tsx"

type Props = {
  title: string
  pages?: PageLink[]
  canGoBack?: boolean
  mainCta?: ReactNode
}

export const PageHeader = ({ title, pages, mainCta, canGoBack }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  const parentLink = useMemo(() => {
    if (!pages) return ""
    const paths = location.pathname.split("/").filter((p) => p)
    if (pages.map((page) => page.link).some((link) => paths.includes(link)))
      return paths.slice(0, -1).join("/")
    return paths.join("/")
  }, [location.pathname, pages])

  const tabValue = useMemo(() => {
    if (!pages) return undefined
    return (
      pages.find((page) => location.pathname.includes(page.link))?.link ??
      head(pages)?.link
    )
  }, [pages, location.pathname])

  return (
    <Box>
      <Stack gap="xs">
        <Group gap="xs" justify="space-between">
          <Group mb="sm">
            {canGoBack && (
              <ActionIcon variant="transparent" onClick={() => navigate(-1)}>
                <IconArrowLeft />
              </ActionIcon>
            )}
            <Title order={1}>{title}</Title>
          </Group>
          <Group>{mainCta}</Group>
        </Group>
        {pages?.length ? (
          <Tabs
            value={tabValue}
            onChange={(value) => navigate(`/${parentLink}/${value}`)}
          >
            <Tabs.List>
              {pages
                .filter((p) => !p.wip)
                .map((page) => (
                  <Tabs.Tab key={page.link} value={page.link}>
                    {page.label}
                  </Tabs.Tab>
                ))}
            </Tabs.List>
          </Tabs>
        ) : (
          <Divider />
        )}
      </Stack>
    </Box>
  )
}
